import React, { useEffect, useRef } from "react";
import { useCharacter, usePubSub } from "@videosdk.live/react-sdk";
import { useAppContext } from "../AppContextDef";
import useIsMobile from "../utils/useIsMobile";
import useIsTab from "../utils/useIsTab";
import { useTranslation } from "react-i18next";
import { logType, useJourney } from "../utils/common";
import usePubsubFunction from "../utils/usePubsubFunction";

function CharacterView({
  agreed,
  characterJoined,
  isCharacterSpeaking,
  setIsCharacterSpeaking,
  messageSent,
  setMessageSent,
  getScreenshotImage,
  isRecorder = false,
  selectedLang,
  sendPreloadAudio = false,
}) {
  const sentRef = useRef(null);
  const micRef = useRef(null);
  const {
    selectedLanguageCode,
    journeyConfig,
    currentPage,
  } = useAppContext();
  let isMobile = useIsMobile();
  let isTab = useIsTab();
  const pubsubPublishMethod = usePubsubFunction()
  let isMobileOrTab = isMobile || isTab;
  const { t, i18n } = useTranslation();
  const { publish } = usePubSub("PRELOAD_AUDIO");
  const { publish: publishCharacter } = usePubSub("SPEAK_PRELOADED_AUDIO");
  const { logJourney } = useJourney()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    changeLanguage(selectedLanguageCode);
  }, [selectedLanguageCode]);

  const { join, micStream, micOn, leave , characterState} =
    useCharacter(
      {
        id: "icici-agent",
        characterMode: "auto_pilot",
        language: isRecorder ? selectedLang?.lang : selectedLanguageCode,
      },
      {
        onCharacterJoined: () => { },
        onError: (data) => {
          const { code,message } = data
          logJourney({
            message: `Character Error : ${message} (${code})`,
            type: logType.ERROR
          })
          if (code === 6001 || code === 6004 || code === 6005 || code === 6018) {
            leave()
          }
        },
        onCharacterStateChanged: (data) => {
          // if (data.status === "CHARACTER_SPEAKING") {
          //   if (isRecorder) setIsCharacterSpeaking(true);
          //   setMessageSent(true);
          // } else {
          //   if (sentRef.current === true) {
          //     setIsCharacterSpeaking(false);
          //   }
          // }
        },
      }
    );

    useEffect(()=>{
      if (characterState === "CHARACTER_SPEAKING") {
            if (isRecorder) setIsCharacterSpeaking(true);
            setMessageSent(true);
          } else {
            if (sentRef.current === true) {
              setIsCharacterSpeaking(false);
            }
          }
    },[characterState])

  useEffect(() => {
    sentRef.current = messageSent;
  }, [messageSent]);

  useEffect(() => {
    if (agreed && !messageSent && !isRecorder && characterJoined) {
      if (isMobileOrTab) {
        setTimeout(() => {
          getScreenshotImage();
        }, 1000);
      } else {
        getScreenshotImage();
      }

      handleCharacterMessage();
    }
  }, [agreed, messageSent, isRecorder, characterJoined]);

  const handleCharacterMessage = () => {
    if (isRecorder) return;
    if (currentPage === "PersonalDetails") {
      pubsubPublishMethod(publishCharacter,
        "Character Interaction",
        { persist: false },
        {
          id: "personalDetails",
          fallback_text: journeyConfig?.voiceoverPersonalDetails,
        }
      );
    }
    if (currentPage === "PolicyDetails") {
      pubsubPublishMethod(publishCharacter,
        "Character Interaction",
        { persist: false },
        {
          id: "policyDetails",
          fallback_text: journeyConfig?.voiceoverPolicyDetails,
        }
      );
    }
    if (currentPage === "VideoConsent") {
      pubsubPublishMethod(publishCharacter,
        "Character Interaction",
        { persist: false },
        {
          id: "consent",
          fallback_text: t(
            "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process."
          ),
        }
      );
    }
    setIsCharacterSpeaking(true);
  };


  useEffect(() => {
    if (!characterJoined && !isRecorder) {
      join();
    }
  }, [characterJoined]);

  useEffect(() => {
    if (characterJoined && !isRecorder && sendPreloadAudio) {
      pubsubPublishMethod(publish,
        "Character Interaction",
        { persist: false },
        {
          id: "personalDetails",
          text: journeyConfig?.voiceoverPersonalDetails,
        }
      );
      pubsubPublishMethod(publish,
        "Character Interaction",
        { persist: false },
        { id: "policyDetails", text: journeyConfig?.voiceoverPolicyDetails }
      );
      pubsubPublishMethod(publish,
        "Character Interaction",
        { persist: false },
        {
          id: "consent",
          text: t(
            "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process."
          ),
        }
      );
    }
  }, [characterJoined, sendPreloadAudio]);

  useEffect(() => {
    if (micRef.current) {
      if ((micOn && micStream) || (isRecorder && micStream)) {
        try {
          const mediaStream = new MediaStream();
          mediaStream.addTrack(micStream.track);
          micRef.current.srcObject = mediaStream;
          micRef.current
            .play()
            .catch((error) =>
              console.error("micRef.current.play() failed", error)
            );
        } catch (error) {
          console.error("Error handling mic stream:", error);
          micRef.current.srcObject = null;
        }
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn, isRecorder]);

  return (
    <div className="flex flex-col">
      {<audio ref={micRef} autoPlay playsInline muted={!isCharacterSpeaking} />}
    </div>
  );
}

export default CharacterView;
